<template>
    <div class="num-text-box">
        <div v-for="item in numStr" :class="`num-text type-${type} n${item}`"/>
    </div>
</template>
<script>
export default {
    name: 'NumText',
    props: {
        num: {
            type: Number,
            default: 0,
        },
        type:{
            type: String,
            default: 'default'
        }
    },
    watch: {
        num:{
            handler(val){
                this.numStr = val.toString()
            },
            immediate:true
        }
    },
    data() {
        return {
            numStr:""
        }
    }
}
</script>
<style scoped lang="less">
.num-text-box{
    font-size:0;
    display: inline-block;
    .num-text{
        display: inline-block;
    }
}

.type-default{
    background: url("../../assets/top/Integral.png") no-repeat;
    background-size:560rem 70rem;
    width:49rem;
    height:62rem;

    &.n0{
        background-position: -3rem -4rem;
    }
    &.n1{
        background-position: -59rem -4rem;
    }
    &.n2{
        background-position: -115rem -4rem;
    }
    &.n3{
        background-position: -171rem -4rem;
    }
    &.n4{
        background-position: -227rem -4rem;
    }
    &.n5{
        background-position: -283rem -4rem;
    }
    &.n6{
        background-position: -339rem -4rem;
    }
    &.n7{
        background-position: -395rem -4rem;
    }
    &.n8{
        background-position: -451rem -4rem;
    }
    &.n9{
        background-position: -507rem -4rem;
    }
}
.type-g{
    background: url("../../assets/top/Integral_no1.png") no-repeat;
    background-size:392rem 49rem;
    width:34rem;
    height:43rem;
    &.n0{
        background-position: -2.5rem -2rem;
    }
    &.n1{
        background-position: -41.5rem-1.5rem -2rem;
    }
    &.n2{
        background-position: -80.5rem-1.5rem -2rem;
    }
    &.n3{
        background-position: -119.5rem-1.5rem -2rem;
    }
    &.n4{
        background-position: -158.5rem-1.5rem -2rem;
    }
    &.n5{
        background-position: -197.5rem-1.5rem -2rem;
    }
    &.n6{
        background-position: -236.5rem-1.5rem -2rem;
    }
    &.n7{
        background-position: -275.5rem-1.5rem -2rem;
    }
    &.n8{
        background-position: -314.5rem-1.5rem -2rem;
    }
    &.n9{
        background-position: -353.5rem-1.5rem -2rem;
    }
}

.type-y{
    background: url("../../assets/top/Integral_no2.png") no-repeat;
    background-size:336rem 42rem;
    width:30rem;
    height:37rem;
    &.n0{
        background-position: -1.8rem -1.5rem;
    }
    &.n1{
        background-position: -35.4rem -1.5rem;
    }
    &.n2{
        background-position: -69rem -1.5rem;
    }
    &.n3{
        background-position: -102.6rem -1.5rem;
    }
    &.n4{
        background-position: -136.2rem -1.5rem;
    }
    &.n5{
        background-position: -169.8rem -1.5rem;
    }
    &.n6{
        background-position: -203.4rem -1.5rem;
    }
    &.n7{
        background-position: -237rem -1.5rem;
    }
    &.n8{
        background-position: -270.6rem -1.5rem;
    }
    &.n9{
        background-position: -304.2rem -1.5rem;
    }
}


.type-j{
    background: url("../../assets/top/Integral_no3.png") no-repeat;
    background-size:336rem 42rem;
    width:30rem;
    height:37rem;
    &.n0{
        background-position: -1.8rem -1.5rem;
    }
    &.n1{
        background-position: -35.4rem -1.5rem;
    }
    &.n2{
        background-position: -69rem -1.5rem;
    }
    &.n3{
        background-position: -102.6rem -1.5rem;
    }
    &.n4{
        background-position: -136.2rem -1.5rem;
    }
    &.n5{
        background-position: -169.8rem -1.5rem;
    }
    &.n6{
        background-position: -203.4rem -1.5rem;
    }
    &.n7{
        background-position: -237rem -1.5rem;
    }
    &.n8{
        background-position: -270.6rem -1.5rem;
    }
    &.n9{
        background-position: -304.2rem -1.5rem;
    }
}
</style>
